<template>
  <vxe-colgroup
    v-bind="columnOption"
    :title="title"
    :show-overflow="showOverflow"
    :show-header-overflow="showHeaderOverflow"
    :fixed="fixed"
    :sortable="sortable || columnOption.sortable"
  >
    <template v-slot:header="{ column }">
      <span v-if="isRequired(column.property)" style="color: red">*</span
      ><span>{{ column.title }}</span>
    </template>
    <template v-if="!columnOption.children" v-slot="scope">
      <slot v-bind="scope" :name="columnOption.prop">
        {{ columnText(scope.$rowIndex, scope.row, columnOption, scope) }}
      </slot>
    </template>

    <template v-for="(col, index) in columnOption.children || []">
      <vxe-column
        v-if="!col.children"
        :key="`${col.prop || ''}${index}`"
        v-bind="col"
        :title="$t(col.label)"
        :field="col.prop"
        :show-overflow="col.isNotAutoWrap == false ? false : 'tooltip'"
        :show-header-overflow="
          col.isNotHeaderAutoWrap == false ? false : 'tooltip'
        "
        :fixed="fixed"
        :sortable="sortable || col.sortable"
        :min-width="col.minWidth"

        :tree-node="isTree && index == 0 && colIndex== 0"
      >
        <template v-slot:header="{ column }">
          <span v-if="isRequired(column.property)" style="color: red">*</span
          ><span>{{ column.title }}</span>
        </template>
        <template  v-slot="scope">
          <slot v-bind="scope" :name="col.prop">{{
            columnText(scope.$rowIndex, scope.row, col, scope)
          }}</slot>
        </template>
      </vxe-column>
      <x-dynamic-column
        v-else
        :key="index"
        :columnOption="col"
        :columnText="columnText"
        :isRequired="isRequired"
        :title="$t(col.label)"
        :showOverflow="col.isNotAutoWrap == false ? false : 'tooltip'"
        :showHeaderOverflow="
          col.isNotHeaderAutoWrap == false ? false : 'tooltip'
        "
        :fixed="fixed"
        :sortable="sortable"
        :allProps="allProps"
        :colIndex="colIndex"
      >
        <template v-for="myProp in allProps || []" v-slot:[myProp]="scope">
          <slot v-bind="scope" :name="myProp"></slot>
        </template>
      </x-dynamic-column>
    </template>
  </vxe-colgroup>
</template>

<script>
export default {
  name: "x-dynamic-column",
  props: {
    columnOption: {
      type: Object,
      required: true,
    },
    columnText: Function,
    isRequired: Function,
    fixed: String,
    sortable: Boolean,
    allProps: {
      type: Array,
      default: () => [],
    },
    showOverflow: [Boolean, String],
    showHeaderOverflow: [Boolean, String],
    title: String,
    colIndex:Number,
  },
  mounted() {},
  methods: {},
};
</script>
